import { Menu, MenuItem } from '@mui/material'
import React from 'react'

const MySortMenu = ({ menuAnchor, setMenuAnchor, handleChooseSort, menuList }) => {
  return (
    <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
      >
        {
            menuList && menuList.length > 0 ?
                menuList.map(item => {
                    return (
                        <MenuItem 
                            key={item.value}
                            onClick={() => handleChooseSort(item.value)}
                        >
                            {item.text}
                        </MenuItem>
                    )
                })
            : ''
        }
        {/* <MenuItem onClick={() => handleChooseSort('reset')}>Скинути</MenuItem>
        <MenuItem onClick={() => handleChooseSort('asc')}>A → Z</MenuItem>
        <MenuItem onClick={() => handleChooseSort('desc')}>Z → A</MenuItem>
        <MenuItem onClick={() => handleChooseSort('numberAsc')}>0 → 9</MenuItem>
        <MenuItem onClick={() => handleChooseSort('numberDesc')}>9 → 0</MenuItem>
        <MenuItem onClick={() => handleChooseSort('custom')}>Кастомне сортування</MenuItem> */}
      </Menu>
  )
}

export default MySortMenu